/*
 * Copyright (c) (2017) - Aikar's Minecraft Timings Parser
 *
 *  Written by Aikar <aikar@aikar.co>
 *    + Contributors (See AUTHORS)
 *
 *  http://aikar.co
 *  http://starlis.com
 *
 *  @license MIT
 *
 */
import React from 'react';
import FA from './FA';

const TimingsBadge = (props) => {
    return (
        <div className={"timings-chart-badge "+props.optionId} onClick={() => props.toggle(props.optionId)}>
            <div className="left">
                {props.optionName}
            </div>
            <div className="right">
              <FA icon={props.enabled ? 'check' : 'times'} />
            </div>
        </div>
    );
};

export default class TimingsChartOptions extends React.Component {
  constructor(props) {
    super(props)
  }
  render() {
    // <!--TimingsBadge optionName="TPS" optionId="tps" enabled={this.props.tps} toggle={this.props.toggle} /-->
    return (
      <div className="timings-chart-options">
        <TimingsBadge optionName="TPS Loss" optionId="tpsLoss" enabled={this.props.tpsLoss} toggle={this.props.toggle} />
        <TimingsBadge optionName="Players" optionId="players" enabled={this.props.players} toggle={this.props.toggle} />
        <TimingsBadge optionName="Entities" optionId="entities" enabled={this.props.entities} toggle={this.props.toggle} />
        <TimingsBadge optionName="Tile Entities" optionId="tileEntities" enabled={this.props.tileEntities} toggle={this.props.toggle} />
        <TimingsBadge optionName="Chunks" optionId="chunks" enabled={this.props.chunks} toggle={this.props.toggle} />
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/js/ui/TimingsChartOptions.jsx